import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommissionAdditionalPromotor } from 'src/app/model/commission-additional-promotor.model';
import { CommissionSimulatorService } from 'src/oldApp/services/commission-simulator.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-modal-commission-additional-promotor',
  templateUrl: './modal-commission-additional-promotor.component.html'
})
export class ModalAdditionalCommissionPromotorComponent implements OnInit {
  @Input() simulateDate:string;
  public additionalPromotor:CommissionAdditionalPromotor;
  public selectedDate: string;
  public validCommission:boolean=false;
  
  constructor(
    private modalService:NgbModal,
    private commissionService:CommissionSimulatorService,
    private toastr:ToastrService
  ) { }

  ngOnInit() {
    this.additionalPromotor = new CommissionAdditionalPromotor();
  }

  onSelectDate(evt:any){
    let d = new Date(evt.year,evt.month-1,evt.day);
    let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    this.selectedDate = [year,month,day].join('-');

  }

  accept(){
    this.additionalPromotor.finalCommission = this.additionalPromotor.commission;
    this.additionalPromotor.createUser = localStorage.getItem("UserId");
    this.additionalPromotor.fechaCobro = this.simulateDate;
    this.additionalPromotor.fechaSimulacion = this.simulateDate;
    this.additionalPromotor.enviado = 0;
    console.log(this.additionalPromotor);
    this.commissionService.saveCommissionCaneAdditionalPromotor(this.additionalPromotor)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.modalService.dismissAll(this.additionalPromotor);
            this.toastr.success('El asesor se agregó exitosamente');
          }else {
            this.toastr.error('Ocurrió un error al agregar al asesor');
          }
        });
  }

  cancel(){
    this.modalService.dismissAll('failure');
  }

  getInfoPromotor(){
    if(this.additionalPromotor.employeeId != undefined){
      this.commissionService.getInfoPromotor(this.additionalPromotor.employeeId)
      .subscribe((resp:any)=> {
        let promotor = JSON.parse(JSON.stringify(resp));
        if(promotor.comercial.length > 0) {
          console.log("RESPUESTA SERVICIO: " + JSON.stringify(promotor));
          this.additionalPromotor.employeeName = promotor.comercial[0].nombreAsesor;
        } else {
          this.toastr.error('No se encontró información');
        }
      });
    } else{
      this.toastr.info('Favor de ingresar datos');
    }
    
  }

  validarComision(){
    if(this.additionalPromotor.commission > 0){
      this.validCommission = true;
    } else {
      this.validCommission = false;
    }
  }
}